class QuickAdd extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initVariantSelectors(); // Initialize variant selectors for product options
    if (window.innerWidth <= 798) this.setupMobile(); // Setup mobile-specific behavior
  }

  checkAutoRotate() {
    // Toggle auto-rotation for sliders within the current section
    const sectionElement = this.closest('section');
    if (sectionElement) {
      const sliderComponents = sectionElement.querySelectorAll('fx-slider-component');
      sliderComponents.forEach((sliderComponent) => {
        // Ensure only sliders with the 'data-auto-rotate' attribute are toggled
        if (sliderComponent.hasAttribute('data-auto-rotate')) {
          sliderComponent.dataset.autoRotate = sliderComponent.dataset.autoRotate === 'true' ? 'false' : 'true';
        }
      });
    }
  }

  displayErrorMessage(message) {
    const errorMessage = this.querySelector('.variant-selector__error-message');
    const swatchContainer = this.querySelector('.variant-selector__choices-wrapper');
    const errorMessageContainer = this.querySelector('.variant-selector__choices-wrapper-error_message');

    if (!errorMessage || !swatchContainer || !errorMessageContainer) return;

    errorMessageContainer.style.display = 'flex';
    swatchContainer.style.display = 'none';
    errorMessage.textContent = message;

    setTimeout(() => {
      errorMessageContainer.style.display = 'none';
      swatchContainer.style.display = 'flex';
    }, 2000);
  }

  setupMobile() {
    // Setup mobile-specific Quick Add functionality
    const cardMediaElement = this.closest('.card--media');
    const fxCarouselElement =
      this.closest('.fx-carousel-products') ??
      this.closest('.collection') ??
      this.closest('section.fx-complete-look') ??
      this.closest('section.related-products') ??
      this.closest('section.recently-viewed-products');
    this.mobileQuickAddCloseBtn = this.querySelector('.mobile-quick-add-clsBtn');
    this.valueName = this.querySelector('.value-name');

    this.mobileQuickAddBtn = cardMediaElement?.querySelector('.product-quick-add__button') || null;
    this.mobileQuickAddContainer = fxCarouselElement?.querySelector('.mobile-quick-add-container') || null;

    const mobileQuickAddBg = this.mobileQuickAddContainer?.nextElementSibling;
    const bodyElement = document.querySelector('body.gradient');

    if (this.mobileQuickAddBtn && this.mobileQuickAddContainer) {
      this.mobileQuickAddBtn.addEventListener('click', () => {
        this.showMobileQuickAdd(bodyElement, mobileQuickAddBg);
        this.checkAutoRotate();
      });
    }

    this.mobileQuickAddCloseBtn?.addEventListener('click', () => {
      this.hideMobileQuickAdd(bodyElement, mobileQuickAddBg);
      this.checkAutoRotate();
    });

    mobileQuickAddBg?.addEventListener('click', () => this.hideMobileQuickAdd(bodyElement, mobileQuickAddBg));
  }

  showMobileQuickAdd(bodyElement, mobileQuickAddBg) {
    // Display the mobile Quick Add container
    document.querySelectorAll('.mobile-quick-add-container').forEach((container) => container.classList.remove('show'));
    this.mobileQuickAddContainer.innerHTML = this.outerHTML;
    this.mobileQuickAddContainer.classList.add('show');

    if (mobileQuickAddBg) mobileQuickAddBg.style.display = 'block';
    if (bodyElement) bodyElement.classList.add('overflow-hidden');

    const newlyInsertedElement = this.mobileQuickAddContainer.querySelector('quick-add');
    newlyInsertedElement?.classList.remove('is-hidden-mobile');

    const mobileAddCartBtn = this.querySelector('.mobileAddCart');
    mobileAddCartBtn?.addEventListener('click', (event) => {
      event.preventDefault();
      this.checkAutoRotate();
      const variantId = event.target.getAttribute('data-variant-id');
      this.addToCart(variantId, 1, mobileAddCartBtn);
    });
  }

  hideMobileQuickAdd(bodyElement, mobileQuickAddBg) {
    // Hide the mobile Quick Add container
    bodyElement?.classList.remove('overflow-hidden');
    if (mobileQuickAddBg) mobileQuickAddBg.style.display = 'none';
    this.mobileQuickAddContainer?.classList.remove('show');
  }

  initVariantSelectors() {
    // Initialize variant selection functionality
    const productId = this.getAttribute('data-product-id');
    const sizeButtons = this.querySelectorAll('.variant-selector__item');

    sizeButtons.forEach((button) => {
      if (!button.disabled) {
        button.addEventListener('click', async (event) => {
          event.preventDefault();
          const variantId = button.getAttribute('data-variant-id');
          await this.addToCart(variantId, 1, button);
        });
      }
    });

    this.setupColorSwatches(productId);
  }

  setupColorSwatches(productId) {
    let colorSwatches = this.querySelectorAll(`.swatch[data-product-id="${productId}"]`);

    // If no swatches inside component, find external "theme" swatches in parent card
    let isExternalSwatches = false;
    if (colorSwatches.length === 0) {
      const cardWrapper = this.closest('.card-wrapper');
      if (cardWrapper) {
        colorSwatches = cardWrapper.querySelectorAll(`.color__swatch--card .swatch[data-product-id="${productId}"]`);
        isExternalSwatches = colorSwatches.length > 0;
      }
    }

    const variantChoices = this.querySelectorAll('.variant-selector__choice');
    const cardContainer = this.closest('.card--media') || null;
    const card_imgs = cardContainer?.querySelectorAll('.card__inner .card__media a img') || [];
    const current_img = [...card_imgs].find((img) => !img.classList.contains('card-hover-img')) || null;
    const hover_img = [...card_imgs].find((img) => img.classList.contains('card-hover-img')) || null;
    const desktop_quick_add_button = this.querySelector('.quick__add.desktop_quick_add_button button') || null;
    const mobileAddCartBtn = this.querySelector('.mobileAddCart') || null;
    let hasSize = false;

    if (desktop_quick_add_button || mobileAddCartBtn) {
      hasSize = true;
    }

    this.valueName = this.querySelector('.value-name') || null;

    let selectedColor = this.getSelectedColor(colorSwatches);

    // Fall back to persisted color (carried via outerHTML into mobile container)
    if (colorSwatches.length === 0 && this.dataset.selectedColor) {
      selectedColor = this.dataset.selectedColor;
    }
    this.dataset.selectedColor = selectedColor;

    if (this.valueName) {
      this.valueName.textContent = selectedColor;
    }

    // Preload a single image on demand
    function preloadImage(src) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(src);
        img.onerror = () => reject(src);
        img.src = src;
      });
    }

    // Preload variant images on hover instead of all at once
    const preloaded = new Set();
    const queuePreload = (src) => {
      if (!src || preloaded.has(src)) return;
      preloaded.add(src);
      preloadImage(src).catch(() => {});
    };
    colorSwatches.forEach((swatch) => {
      swatch.addEventListener(
        'mouseenter',
        () => {
          queuePreload(swatch.querySelector('span.color-swatch')?.dataset.variantImageLink);
          queuePreload(swatch.dataset.variantHoverImageLink);
        },
        { passive: true }
      );
    });

    const updateSizeOptions = () => {
      variantChoices.forEach((choice) => {
        choice.style.display = choice.getAttribute('data-color') === selectedColor ? 'flex' : 'none';
      });
    };
    updateSizeOptions();

    colorSwatches.forEach((swatch) => {
      swatch.addEventListener('click', (event) => {
        if (!isExternalSwatches) event.preventDefault();
        const span = swatch.querySelector('span.color-swatch');
        const variant_id = swatch.dataset.variantId;
        const variant_inventory = swatch.dataset.variantInventory;
        const inventory_policy = swatch.dataset.inventoryPolicy;

        // Only handle image swap for internal swatches; external "theme" swatches have their own script
        if (!isExternalSwatches) {
          const variant_img = span.dataset.variantImageLink;
          const hover_variant_img = swatch.dataset.variantHoverImageLink;
          const alt = span.getAttribute('data-color-value') || '';

          if (variant_img && current_img) {
            current_img.classList.remove('fade-in');
            current_img.onload = () => {
              current_img.classList.add('fade-in');
            };
            setTimeout(() => {
              current_img.src = variant_img;
              current_img.srcset = variant_img;
              current_img.alt = alt;
            }, 200);
          }

          if (hover_variant_img && hover_img) {
            hover_img.classList.remove('fade-in');
            hover_img.onload = () => {
              hover_img.classList.add('fade-in');
            };
            setTimeout(() => {
              hover_img.src = hover_variant_img;
              hover_img.srcset = hover_variant_img;
              hover_img.alt = alt;
            }, 200);
          }
        }

        if (hasSize) {
          desktop_quick_add_button.setAttribute('data-variant-id', variant_id);
          mobileAddCartBtn.setAttribute('data-variant-id', variant_id);
          desktop_quick_add_button.disabled = variant_inventory == 0 && inventory_policy !== 'continue' ? true : false;
          mobileAddCartBtn.disabled = variant_inventory == 0 && inventory_policy !== 'continue' ? true : false;

          const labelSpanDesktop = desktop_quick_add_button.querySelector('span');
          const labelSpanMobile = mobileAddCartBtn.querySelector('span');

          if (desktop_quick_add_button.disabled) {
            labelSpanDesktop.innerHTML = 'Sold out';
          } else {
            labelSpanDesktop.innerHTML = 'Add to cart';
          }

          if (mobileAddCartBtn.disabled) {
            labelSpanMobile.innerHTML = 'Sold out';
          } else {
            labelSpanMobile.innerHTML = 'Add to cart';
          }
        }

        // Only toggle selected-color for internal swatches; external script handles its own
        if (!isExternalSwatches) {
          colorSwatches.forEach((s) => s.classList.remove('selected-color'));
          swatch.classList.add('selected-color');
        }

        selectedColor = swatch.getAttribute('data-color-value');
        this.dataset.selectedColor = selectedColor;
        if (this.valueName) this.valueName.textContent = selectedColor;
        updateSizeOptions();
      });
    });

    // Initial sync. Re-point the primary <img> at the selected swatch so the card shows
    // the default-selected colour rather than whatever Liquid painted as media[0] (the
    // product featured image). This keeps the primary consistent with the selected swatch
    // — important once swatches can be reordered, where the default colour need not be the
    // featured one. No-op when they already agree, so unaffected cards never reflow.
    // Then sync the hover <img> to the selected swatch's initial-hover image.
    if (!isExternalSwatches) {
      const selectedSwatch = [...colorSwatches].find((s) => s.classList.contains('selected-color'));
      if (selectedSwatch) {
        const selected_alt = selectedSwatch.dataset.colorValue || '';

        if (current_img) {
          const span = selectedSwatch.querySelector('span.color-swatch');
          const primary_img = (span && span.dataset.variantImageLink) || selectedSwatch.dataset.variantImageLink;
          if (primary_img && current_img.getAttribute('src') !== primary_img) {
            current_img.src = primary_img;
            current_img.srcset = primary_img;
            current_img.alt = selected_alt;
          }
        }

        if (hover_img) {
          const initial_hover = selectedSwatch.dataset.initialHoverImageLink;
          if (initial_hover && hover_img.getAttribute('src') !== initial_hover) {
            hover_img.src = initial_hover;
            hover_img.srcset = initial_hover;
            hover_img.alt = selected_alt;
          }
        }
      }
    }
  }

  getSelectedColor(colorSwatches) {
    // Get the currently selected color swatch
    return (
      [...colorSwatches]
        .find((swatch) => swatch.classList.contains('selected-color'))
        ?.getAttribute('data-color-value') || ''
    );
  }

  async addToCart(variantId, quantity, button) {
    try {
      const isPreorder = this.dataset.isPreorder === 'true';
      const bodyData = isPreorder
        ? { id: variantId, quantity, properties: { PreOrder: 'PreOrder' } }
        : { id: variantId, quantity };

      this.showLoadingState(true, button);
      await CartUtils.addToCartAndOpen(bodyData);
    } catch (error) {
      const message = error.cartResponse?.description || 'Unable to add item to cart.';
      this.displayErrorMessage(message);
      console.error('Error adding item to cart:', error);
    } finally {
      this.showLoadingState(false, button);
    }
  }

  showLoadingState(isLoading, button) {
    // Show or hide a loading indicator on the button
    if (isLoading) {
      button.dataset.originalContent = button.dataset.originalContent || button.innerHTML;
      button.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" width="25" height="25" style="shape-rendering: auto; background: transparent;" class="loading-spinner"><circle stroke-dasharray="164.93 56.98" r="35" stroke-width="5" stroke="currentColor" fill="none" cy="50" cx="50"><animateTransform keyTimes="0;1" values="0 50 50;360 50 50" dur="1.3s" repeatCount="indefinite" type="rotate" attributeName="transform"></animateTransform></circle></svg>`;
      button.disabled = true;
    } else {
      button.innerHTML = button.dataset.originalContent;
      button.disabled = false;
    }
  }
}

if (!customElements.get('quick-add')) {
  customElements.define('quick-add', QuickAdd);
}
